/**
 * Unified Priority Badge Configuration
 * Provides consistent color mapping for priority levels across all components
 * 
 * Color Scheme:
 * - Low: secondary (grey)
 * - Medium: warning (yellow/orange)
 * - High: danger (red)
 * - Critical: danger (red) - most severe
 */

export const PRIORITY_BADGE_VARIANTS = {
  "Low": "secondary",
  "Medium": "warning",
  "High": "danger",
  "Critical": "danger"
};

/**
 * Get the badge variant for a priority level
 * @param {string} priority - The priority level
 * @returns {string} - Bootstrap badge variant
 */
export const getPriorityBadgeVariant = (priority) => {
  return PRIORITY_BADGE_VARIANTS[priority] || "secondary";
};
